import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Loader, Statistic } from "semantic-ui-react";
import { isFacultyUser } from "../../../../../UserRoleUtils";

export default class PatronOverview extends Component {
  scrollTo(ref) {
    ref.current.scrollIntoView(false, { behaviour: "smooth", block: "end" });
  }

  renderStatistic(stat, quantifiableLabel, anchor) {
    const {
      isLoading,
      data: { total },
    } = stat;

    return (
      <Statistic onClick={() => this.scrollTo(anchor)} className="anchored">
        <Statistic.Value>
          {isLoading ? <Loader active inline /> : total}
        </Statistic.Value>
        <Statistic.Label>
          {isLoading ? <>&nbsp;</> : quantifiableLabel(total !== 1)}
        </Statistic.Label>
      </Statistic>
    );
  }

  render() {
    const {
      currentLoans,
      loanRequests,
      documentRequests,
      anchors,
      userRole,
      user,
    } = this.props;

    // Check if user has faculty role
    const showDocumentRequests = isFacultyUser(userRole, user);
    const statisticsWidth = showDocumentRequests ? "three" : "two";

    return (
      <Container className="spaced">
        <Statistic.Group widths={statisticsWidth} size="small">
          {this.renderStatistic(
            currentLoans,
            (isPlural) => `ongoing loan${isPlural ? "s" : ""}`,
            anchors.currentLoansRef
          )}
          {this.renderStatistic(
            loanRequests,
            (isPlural) => `loan request${isPlural ? "s" : ""}`,
            anchors.pendingLoansRef
          )}
          {/* Conditionally render documentRequests only for faculty */}
          {showDocumentRequests &&
            this.renderStatistic(
              documentRequests,
              (isPlural) => `Request${isPlural ? "s" : ""} for new literature`,
              anchors.currentDoqRequestsRef
            )}
        </Statistic.Group>
      </Container>
    );
  }
}

PatronOverview.propTypes = {
  currentLoans: PropTypes.object,
  loanRequests: PropTypes.object,
  documentRequests: PropTypes.object,
  anchors: PropTypes.object.isRequired,
  userRole: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

PatronOverview.defaultProps = {
  currentLoans: { isLoading: false, data: { total: 0 } },
  loanRequests: { isLoading: false, data: { total: 0 } },
  documentRequests: { isLoading: false, data: { total: 0 } },
};
